// Section 8: Water carrier. 3.0 water (5.0 with a well, via the well's modifier). Bucket 1.3x;
// 1% illness from fouled water. Constants: config.jobs['water-carrier'].
import type { Config } from '../../config';
import { alwaysEligible, produced } from '../../core/content-helpers';
import { defineJob, noModifiers } from '../../core/registry';

export function waterCarrier(config: Config) {
  const c = config.jobs['water-carrier'];

  return defineJob({
    id: 'water-carrier',
    label: 'Water carrier',
    section: 'S8',
    heavy: false,
    output: { kind: 'stock', resource: 'water' },
    baseYield: c.yield,
    toolFactor: c.toolFactor,
    toolWear: 0,
    risks: { illness: c.illness },
    riskIllness: 'flux',
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: [],
    modifiers: noModifiers,
    produce: (_ctx, _worker, output) => (output > 0 ? [produced('water', output)] : []),
    eligible: alwaysEligible,
  });
}
